var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pricing-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        !_vm.loading && _vm.data && _vm.data.pricing_analytics
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewChart"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewChart') }",
                          },
                        ],
                        attrs: {
                          classNames:
                            _vm.viewMode === "chart" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "chart")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsPieChart"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsPieChart') }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.viewMode === "pie" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "pie")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("donut_small")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewTable"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewTable') }",
                          },
                        ],
                        attrs: {
                          classNames:
                            _vm.viewMode === "table" ? "selected" : "",
                          onClick: function () {
                            return (_vm.viewMode = "table")
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsDownloadExcel"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsDownloadExcel') }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalVolume"
                      ),
                      value: _vm.totalVolume,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalCost"
                      ),
                      value: _vm.totalCost.toFixed(2),
                      unit: "$",
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsAvgUnitCost"
                      ),
                      value: _vm.avgCostPerMessage.toFixed(4),
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsCostPerMessage"
                      ),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pricing-breakdown" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "whatsapp_business_api.metaInsightsPricingCategoryBreakdown"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pricing-cards" },
                  _vm._l(
                    _vm.pricingCategoryBreakdown,
                    function (value, category) {
                      return _c(
                        "div",
                        { key: category, staticClass: "pricing-card" },
                        [
                          _c("div", { staticClass: "pricing-name" }, [
                            _vm._v(
                              _vm._s(_vm.getPricingCategoryLabel(category))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pricing-volume" }, [
                            _vm._v(
                              _vm._s(value.volume) +
                                " " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.metaInsightsUnitMessage"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pricing-cost" }, [
                            _vm._v("$" + _vm._s(value.cost.toFixed(2))),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pricing-type-breakdown" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "whatsapp_business_api.metaInsightsPricingTypeBreakdown"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pricing-cards" },
                  _vm._l(_vm.pricingTypeBreakdown, function (value, type) {
                    return _c(
                      "div",
                      { key: type, staticClass: "pricing-card" },
                      [
                        _c("div", { staticClass: "pricing-name" }, [
                          _vm._v(_vm._s(_vm.getPricingTypeLabel(type))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pricing-volume" }, [
                          _vm._v(
                            _vm._s(value.volume) +
                              " " +
                              _vm._s(
                                _vm.$t(
                                  "whatsapp_business_api.metaInsightsUnitMessage"
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pricing-cost" }, [
                          _vm._v("$" + _vm._s(value.cost.toFixed(2))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.viewMode === "chart"
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: _vm.$t(
                            "whatsapp_business_api.metaInsightsPricingStats"
                          ),
                          "x-axis-data": _vm.getXAxisData(),
                          legends: _vm.getPricingLegends(),
                          colors: _vm.pricingColors,
                          series: _vm.getPricingSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewMode === "pie"
                ? _c(
                    "div",
                    { staticClass: "pie-container" },
                    [
                      _c("PieChartV2", {
                        attrs: {
                          title: _vm.$t(
                            "whatsapp_business_api.metaInsightsCostDistribution"
                          ),
                          legends: _vm.getPricingLegends(),
                          series: _vm.getPieSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewMode === "table"
                ? _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description: _vm.$t(
                      "whatsapp_business_api.metaInsightsNoData"
                    ),
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }